import { useModulePermission } from '@sdx/b2o-fe-tools';
import type { ModuleName } from '@sdx/b2o-fe-tools';

type UseWorkforceSizingPermissionProps = {
  accessToken: string | null;
  baseUrl: string;
  siteCode?: string;
};

type WorkforceSizingPermissionState = {
  isChecking: boolean;
  hasAccess: boolean | null;
};

const WORKFORCE_SIZING_MODULE: ModuleName = 'workforce-sizing';

export const useWorkforceSizingPermission = ({
  accessToken,
  baseUrl,
  siteCode,
}: UseWorkforceSizingPermissionProps): WorkforceSizingPermissionState => {
  const { permissions, isLoading, hasError, canExecute } = useModulePermission(
    WORKFORCE_SIZING_MODULE,
    {
      baseUrl,
      accessToken: accessToken ?? undefined,
      siteCode: siteCode ?? undefined,
    },
  );

  if (!canExecute || isLoading) {
    return { isChecking: true, hasAccess: null };
  }

  if (hasError || !permissions) {
    return { isChecking: false, hasAccess: false };
  }

  return { isChecking: false, hasAccess: permissions.canRead };
};
